// src/App.tsx
import React, { Suspense } from 'react';
import {
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";
import "./App.scss";
// Version Control Imports
import { VersionProvider, useVersionContext } from "./context/VersionContext";// Add this import
import { getAvailableFoundations, getAvailableIntroductions } from "./versions/versionRegistry";  // Add this import
import { AppRoutes } from './routes/AppRoutes'; // Create this new file
//Pages and Layout Imports
import Header from "./layout/header";
import Sidebar from "./layout/sidebar";
import Foundations from "./pages/foundations";
import IntroductionsMenu from "./pages/introduction-menu";
import Showlandingpage from "../src/pages/landingpage";
/*importing component versions*/
// import Version1Routes from './routes/Version1Routes';
// import Version2Routes from './routes/Version2Routes';
/*end of importing component versions*/


const SidebartoShowHide = () => {
    const location = useLocation();
  const { currentVersion } = useVersionContext();  // Access current version

  const showFoundationsidebar = location.pathname.startsWith("/foundations");
  const showComponentsidebar = location.pathname.startsWith("/components");
  const showIntroductionsidebar = location.pathname.startsWith("/introductions");

   // Compute items for Foundations using version registry
  const foundationItems = getAvailableFoundations(currentVersion.id).map(f => ({
    name: f.name,
    path: f.path,
    deprecated: f.deprecated,  // Optional, matches interface
  }));
   // Compute items for Foundations using version registry
  const introductionItems = getAvailableIntroductions(currentVersion.id).map(f => ({
    name: f.name,
    path: f.path,
    deprecated: f.deprecated,  // Optional, matches interface
  }))
  return (
    <div>
      {showComponentsidebar && <Sidebar />}
      {showFoundationsidebar && <Foundations items={foundationItems} currentPath={location.pathname} />}
      {showIntroductionsidebar && <IntroductionsMenu items={introductionItems} currentPath={location.pathname}  />}
    </div>
  );
};

const ShowLanding = () => {
  const location = useLocation();
  const showLandingpages = location.pathname === "/designsystem";
  return <div>{showLandingpages && <Showlandingpage />}</div>;
};

const AppLayout = () => {
  const location = useLocation();
  
  // Determine if we're on a page that needs sidebar
  const needsSidebar = 
    location.pathname.startsWith("/components") ||
    location.pathname.startsWith("/foundations") ||
    location.pathname.startsWith("/introductions");

  return (
    <div>
      <Header />
      
      {needsSidebar ? (
        <div>
          <SidebartoShowHide />
          <div className="body-content">
            <Suspense fallback={<div style={{ padding: '20px' }}>Loading...</div>}>
              <AppRoutes />
            </Suspense>
          </div>
        </div>
      ) : (
        <div className="body-content-fullwidth">
          <Suspense fallback={<div style={{ padding: '20px' }}>Loading...</div>}>
            <AppRoutes />
          </Suspense>
        </div>
      )}
    </div>
  );
};
function App() {
  return (
    <Router>
      <VersionProvider>
        <AppLayout />
      </VersionProvider>
    </Router>
  );
}

export default App;
